import React from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import styles from "./styles.module.scss";
import moment from "moment";

import { customTableStylesReport, fallbackIfEmpty } from "utils/Utils";

const Table = ({ dados, loading, actionFilter, totalRecords }) => {
  const columns = [
    {
      name: "Usuário",
      selector: "name",
      sortable: true,
      center: true,
      width: "200px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {fallbackIfEmpty(d.name)}
        </span>
      ),
    },
    {
      name: "Login",
      selector: "login",
      sortable: true,
      center: true,
      width: "200px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {fallbackIfEmpty(d.login)}
        </span>
      ),
    },
    {
      name: "E-mail corporativo",
      selector: "email",
      sortable: true,
      wrap: true,
      center: true,
      width: "280px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {fallbackIfEmpty(d.email)}
        </span>
      ),
    },
    {
      name: "Código do colaborador",
      selector: "employeeCode",
      sortable: true,
      center: true,
      cell: (d) => fallbackIfEmpty(d.employeeCode),
    },
    {
      name: "Usuário ativo",
      selector: "active",
      sortable: true,
      center: true,
      cell: (d) => <>{Boolean(d.active) ? "SIM" : "NÃO"}</>,
    },
    {
      name: "Empresa",
      selector: "company",
      sortable: true,
      center: true,
      width: "200px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {fallbackIfEmpty(d.company)}
        </span>
      ),
    },
    {
      name: "Login do Gestor",
      selector: "managerLogin",
      sortable: true,
      center: true,
      cell: (d) => fallbackIfEmpty(d.managerLogin),
    },
    {
      name: "Departamento",
      selector: "department",
      sortable: true,
      center: true,
      cell: (d) => fallbackIfEmpty(d.department),
    },
    {
      name: "Unidade",
      selector: "unit",
      sortable: true,
      center: true,
      cell: (d) => fallbackIfEmpty(d.unit),
    },
    {
      name: "Cargo",
      selector: "role",
      sortable: true,
      center: true,
      cell: (d) => fallbackIfEmpty(d.role),
    },
    {
      name: "Data de criação",
      selector: "creationDate",
      sortable: true,
      center: true,
      style: {
        whiteSpace: "nowrap",
      },
      cell: (d) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {d.creationDate ? moment(d.creationDate).format("DD/MM/YYYY") : "-"}
        </span>
      ),
    },
    {
      name: "Data e hora do ultimo acesso",
      selector: "lastAccess",
      sortable: true,
      center: true,
      style: {
        whiteSpace: "nowrap",
      },
      cell: (d) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {d.lastAccess ? moment(d.lastAccess).format("DD/MM/YYYY HH:mm") : "-"}
        </span>
      ),
    },
    {
      name: "Administrador",
      selector: "admin",
      sortable: true,
      center: true,
      cell: (d) => <>{Boolean(d.admin) ? "SIM" : "NÃO"}</>,
    },
    {
      name: "Aceite aos termos",
      selector: "userLicenceTermsAccepted",
      sortable: true,
      center: true,
      cell: (d) => <>{Boolean(d.userLicenceTermsAccepted) ? "SIM" : "NÃO"}</>,
    },
    {
      name: "Aceite a comunicação",
      selector: "communicationAccepted",
      sortable: true,
      center: true,
      cell: (d) => <>{Boolean(d.communicationAccepted) ? "SIM" : "NÃO"}</>,
    },
  ];

  // const customTableStyles = {
  //   table: {
  //     style: {
  //       tableLayout: "auto", // permite largura dinâmica das colunas
  //     },
  //   },
  //   cells: {
  //     // center: true,
  //     style: {
  //       textAlign: "center",
  //       justifyContent: "center",
  //       whiteSpace: "normal", // permite quebra de linha
  //       overflow: "visible",
  //       textOverflow: "unset",
  //       wordBreak: "break-word",
  //       width: "150px",
  //     },
  //   },
  //   headCells: {
  //     // center: true,
  //     style: {
  //       textAlign: "center",
  //       justifyContent: "center",
  //       whiteSpace: "normal",
  //       fontWeight: "bold",
  //       position: "relative", // necessário para que o sortable fique absoluto em relação ao th
  //       padding: "0 0 0 12px", // espaço pro ícone
  //     },
  //   },
  //   sortIcon: {
  //     style: {
  //       position: "absolute",
  //       top: "50%",
  //       right: "8px",
  //       transform: "translateY(-50%)",
  //       pointerEvents: "none", // opcional, evita que o clique no ícone interfira
  //     },
  //   },
  // };

  const tableData = {
    columns: columns,
    data: dados,
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Usuários por página",
    rangeSeparatorText: "de",
  };

  const onChangePage = (page, totalRows) => {
    actionFilter({ offset: --page * dados.length });
  };

  const onChangeRowsPerPage = (limit) => {
    actionFilter({ limit, offset: 0 });
  };

  const loadingComponent = () => {
    return (
      <div className="tela-login-loading">
        <div className="loader-container" style={{ margin: "300px 0" }}>
          <div
            style={{
              position: "initial",
              margin: "initial",
            }}
            className="loader loader-center loader-big"
          ></div>
          <span
            style={{
              marginTop: 10,
              fontSize: 20,
            }}
          >
            Carregando dados...
          </span>
        </div>
      </div>
    );
  };

  return (
    <DataTableExtensions
      filter={false}
      print={false}
      {...tableData}
      exportHeaders={false}
      export={false}
    >
      <DataTable
        columns={columns}
        data={dados}
        className={styles.dataTableFormat}
        customStyles={customTableStylesReport}
        progressPending={loading}
        progressComponent={loadingComponent()}
        noHeader={true}
        noDataComponent="Não foi encontrado nenhum dado"
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationTotalRows={totalRecords}
        paginationComponentOptions={paginationComponentOptions}
        paginationServer
        pagination
      />
    </DataTableExtensions>
  );
};

export default Table;
